import React from 'react';
import { withTranslation } from 'react-i18next';

class NotFoundComponent extends React.Component {
    render() { 
        return (<div>Not Found</div>)
    }
}
export default withTranslation("translation")(NotFoundComponent);
